module.exports = __webpack_public_path__ + "media/images/icons/profile-edit-25b6caecff42a948adc68d83c720ec59.svg";